import { Body, Tooltip } from '@panwds/react-ui'
import { ExclamationTriangleIcon } from '@panwds/icons'


const WithWarningCellRenderer = ({ row, value }) => {
  const { original: { disabled = false, reason, hasWarning, warningMessage } } = row

  // disabled - top priority
  if (disabled) {
    return <Tooltip label={reason}>
      <div className='tw-h-full tw-truncate'>
        <Body size="lg" addClassName='tw-truncate tw-text-disabled'>{value}{'   '}{hasWarning && <ExclamationTriangleIcon />}</Body>
      </div>
    </Tooltip>
  }

  // warning - second priority (if not disabled)
  if (hasWarning) {
    return <Tooltip label={warningMessage}>
      <div className='tw-h-full tw-truncate'>
        <Body size="lg" addClassName='tw-truncate'>{value}{'   '}<ExclamationTriangleIcon /></Body>
      </div>
    </Tooltip>
  }

  // regular - last (if not disabled, warning)
  return <div className='tw-h-full tw-truncate'>
    <Body size="lg" addClassName='tw-truncate'>{value}</Body>
  </div>
}

export default WithWarningCellRenderer
